export interface SEOData {
  title: string
  description: string
  h1: string
  micromarking: string
  slug?: string | null
}

export const initialSEOData: SEOData = {
  title: '',
  description: '',
  h1: '',
  micromarking: '',
  slug: null
}
